module.exports = ":host ::ng-deep .ui-progressbar{\n    top: 0.5rem !important;\n}\n\n:host ::ng-deep .botones-formularios{\n    margin-top: 0 !important;\n}"